var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-login.ts
import { authorizeOAuth } from "@adornis/authentication/oauth-provider/client/authorizeOAuth.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-overlay.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { currentUser } from "@adornis/users/client/currentUser.js";
import { login } from "@adornis/users/client/loginFunctions.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { filter, firstValueFrom } from "rxjs";
import "./x-login-input.js";
var XLogin = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._errorMessage = "";
    this._loading = false;
    this.translateError = (error) => `Fehler beim Einloggen: ${error.message}`;
    this.placeholderUsername = "Username";
    this.placeholderPassword = "Password";
    this.usernameResetRoute = "";
    this.passwordResetRoute = "";
    this.useOauth = false;
    this.noOverlay = false;
  }
  styles() {
    return [{ ":host": { display: "block" } }];
  }
  async preLogin({ username, password }) {
    if (!password?.length || !username?.length)
      throw new Error("Inputs are empty");
  }
  async login({ username, password }) {
    if (!password?.length || !username?.length)
      throw new Error("Inputs are empty");
    if (this.useOauth) {
      await authorizeOAuth(username, password);
    } else {
      await login(username, password);
      await firstValueFrom(currentUser().whenReady.pipe(filter(Boolean)));
      this.dispatchEvent(new CustomEvent("login"));
    }
  }
  async _login() {
    this._errorMessage = "";
    this._loading = true;
    try {
      await this.preLogin({ username: this._email, password: this._password });
      await this.login({ username: this._email, password: this._password });
    } catch (error) {
      this._errorMessage = this.translateError(error);
    } finally {
      this._loading = false;
    }
  }
  _setError(error) {
    this._errorMessage = error.message;
  }
  connectedCallback() {
    super.connectedCallback();
    let params = new URL(document.location.toString()).searchParams;
    if (params.get("error_message")) {
      this._errorMessage = params.get("error_message");
    }
  }
  render() {
    const inputs = html` <x-flex space="md">
      <x-login-input
        ${css({ width: "100%" })}
        ?disabled=${this._loading}
        name="username"
        id="username"
        type="text"
        placeholder-mode="inline-floating"
        autocomplete
        @submit=${() => this._login()}
        @value-changed=${(e) => this._email = e.detail.value || ""}
        placeholder=${this.placeholderUsername}
      ></x-login-input>
      ${this.usernameResetRoute ? xComponents(html`
            <x-link @click=${() => goTo(this.usernameResetRoute)}>
              <x-text>${this.placeholderUsername} vergessen?</x-text>
            </x-link>
          `) : nothing}
      <x-login-input
        ${css({ width: "100%" })}
        .disabled=${this._loading}
        name="password"
        id="password"
        type="password"
        @value-changed=${(e) => this._password = e.detail.value || ""}
        @submit=${() => this._login()}
        placeholder=${this.placeholderPassword}
      ></x-login-input>
      ${this.passwordResetRoute ? xComponents(html`
            <x-link @click=${() => goTo(this.passwordResetRoute)}>
              <x-text>${this.placeholderPassword} vergessen?</x-text>
            </x-link>
          `) : nothing}
    </x-flex>`;
    return xComponents(html`
      <x-flex center crossaxis-center ${css({ height: "100%" })}>
        <x-flex space="md" ${css({ maxWidth: this.sizes.maxReadableWidth })}>
          ${this.headerSrc ? html`
                <x-flex crossaxis-center>
                  <img src=${this.headerSrc} alt="Logo" ${css({ maxWidth: "200px" })} />
                </x-flex>
              ` : nothing}
          <slot name="header"></slot>
          <slot name="login-fields"></slot>
          ${!this.noOverlay ? html`<x-overlay>${inputs}</x-overlay>` : html`${inputs}`}
          ${this._errorMessage ? html` <x-text align="center" tone="error" ${css({ maxWidth: "200px" })}> ${this._errorMessage} </x-text> ` : nothing}
          <x-button ?disabled=${this._loading} @click=${() => this._login()}> Login </x-button>
          <slot></slot>
        </x-flex>
      </x-flex>
    `);
  }
};
__decorateClass([
  state()
], XLogin.prototype, "_errorMessage", 2);
__decorateClass([
  state()
], XLogin.prototype, "_loading", 2);
__decorateClass([
  property({ attribute: "header-src" })
], XLogin.prototype, "headerSrc", 2);
__decorateClass([
  property({ attribute: "placeholder-username" })
], XLogin.prototype, "placeholderUsername", 2);
__decorateClass([
  property({ attribute: "placeholder-password" })
], XLogin.prototype, "placeholderPassword", 2);
__decorateClass([
  property({ attribute: "user-reset-route" })
], XLogin.prototype, "usernameResetRoute", 2);
__decorateClass([
  property({ attribute: "password-reset-route" })
], XLogin.prototype, "passwordResetRoute", 2);
__decorateClass([
  property({ type: Boolean, attribute: "use-oauth" })
], XLogin.prototype, "useOauth", 2);
__decorateClass([
  property({ type: Boolean, attribute: "no-overlay" })
], XLogin.prototype, "noOverlay", 2);
XLogin = __decorateClass([
  customElement("x-login")
], XLogin);
export {
  XLogin
};
